import { call, put, takeLatest, } from 'redux-saga/effects'
import * as ActionTypes from './actionTypes'
import * as Actions from './action'
import { NetworkingProvider } from 'src/features/Security/networking/networkingProvider'
import { Urls } from 'src/common/urls'
import { getErrorFromResponse } from 'src/features/Security/networking/util'
import { SystemDescriptions } from 'src/common/descriptions'

function* getUsersApi() {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().get, Urls.BACKEND.USER.GET_RECORDS())
        yield put(Actions.getUsersApiSuccess(response.data))
    } catch (err) {
        yield put(Actions.getUsersApiError(getErrorFromResponse(err)));
    }
}

function* upsertUserApi(action: Actions.UpsertUserAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().post, Urls.BACKEND.USER.UPSERT, action.user)
        yield put(Actions.upsertUserApiSuccess(response.data))
    } catch (err: any) {
        if (err?.response?.data?.error?.code === 409) {
            err.response.data.error.message = SystemDescriptions.PAGES.USER.CREATE.ERROR_USERNAME_ALREADY_USED
        }
        yield put(Actions.upsertUserApiError(getErrorFromResponse(err)));
    }
}

function* getUserRolesApi() {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().get, Urls.BACKEND.USER_ROLE.GET_RECORDS())
        yield put(Actions.getUserRolesApiSuccess(response.data))
    } catch (err: any) {
        yield put(Actions.getUserRolesApiError(getErrorFromResponse(err)));
    }
}

function* getUserByIdApi(action: Actions.GetUserByIdAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().get, Urls.BACKEND.USER.GET_BY_ID(action.userId))
        yield put(Actions.getUserByIdApiSuccess(response.data))
    } catch (err: any) {
        yield put(Actions.getUserByIdApiError(getErrorFromResponse(err)));
    }
}

function* updateUserPasswordApi(action: Actions.UpdateUserPasswordAction) {
    try {
        const response = yield call(NetworkingProvider.getInstance().getControlInterface().post, Urls.BACKEND.USER.UPDATE_PASSWORD, action.request)
        yield put(Actions.updateUserPasswordApiSuccess(response.data))
    } catch (err: any) {
        if (err?.response?.data?.error?.code === 409) {
            err.response.data.error.message = SystemDescriptions.PAGES.USER.CREATE.ERROR_USERNAME_ALREADY_USED
        }
        yield put(Actions.updateUserPasswordApiError(getErrorFromResponse(err)));
    }
}

export default function* securitySagas() {
    yield takeLatest(ActionTypes.GET_USERS_API, getUsersApi)
    yield takeLatest(ActionTypes.UPSERT_USER_API, upsertUserApi)
    yield takeLatest(ActionTypes.GET_USER_ROLES_API, getUserRolesApi)
    yield takeLatest(ActionTypes.GET_USER_BY_ID_API, getUserByIdApi)
    yield takeLatest(ActionTypes.UPDATE_USER_PASSWORD_API, updateUserPasswordApi)
}